import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./DeepSearchBanner.scss";
import info from "assets/icons/search/info.svg";

interface IDeepSearch {
    search_depth: any;
    isfeatured: boolean;
    locations: any;
}
const DeepSearchBanner: React.FC<IDeepSearch> = ({ search_depth, isfeatured, locations }) => {
    const {t} = useTranslation();
    const [infoText, updateInfoText] = useState({ primary: "", secondary: "" })

    useEffect(() => {
        if (search_depth) {
            updateInfoText({
                primary: t('infoTxt.text1'),
                secondary: t('infoTxt.text2')
            })
        }
        else if (isfeatured && !locations) {
            updateInfoText({
                primary: t('infoTxt.text3'),
                secondary: t('infoTxt.text4')
            })
        }
        else if (isfeatured && locations) {
            updateInfoText({
                primary: `${t('infoTxt.text5')} ${locations} ${t('infoTxt.text6')}`,
                secondary: t('infoTxt.text4')
            })
        }
        // eslint-disable-next-line
    }, [search_depth, isfeatured, locations])

    return (
        <>
            <div className="noresult-banner">
                <div className="noresult-info"><img src={info} alt="info"></img></div>
                <div>
                    <div className="noresult-dynamic">{infoText.primary}</div>
                    <div className="noresult-static">{infoText.secondary}</div>
                </div>
            </div>
        </>
    );
};

export default DeepSearchBanner;
